import { Assets } from './Assets'

export const OtherAssets = ({ assets, handleOnClick }) => {
  const otherAssets = (assets || []).filter(
    (option) => option.subType === OtherAssets.targetCategory
  )
  return (
    <Assets
      assets={otherAssets}
      handleOnClick={handleOnClick}
      category={OtherAssets.targetCategory}
    />
  )
}
OtherAssets.targetCategory = 'otherassets'
